export const montarEnderecoMaps = ({ endereco, numero, bairro, cidade, estado, cep }) => {
  return [endereco, numero, bairro, cidade, estado, cep]
    .map((parte) => String(parte ?? "").trim())
    .filter(Boolean)
    .join(", ");
};

export const temEnderecoMinimo = ({ endereco, cidade, cep }) => {
  const enderecoNormalizado = String(endereco ?? "").trim();
  const cidadeNormalizada = String(cidade ?? "").trim();
  const cepNormalizado = String(cep ?? "").trim();

  return Boolean(enderecoNormalizado && (cidadeNormalizada || cepNormalizado));
};

export const abrirNoMaps = (partes) => {
  const query = montarEnderecoMaps(partes);
  if (!query) return;

  const url = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
  window.open(url, "_blank");
};
